module.exports = __webpack_public_path__ + "static/media/add_user.72603a06.png";